class HelperFunctions {
  constructor() {
    this.nameRegex = /^[A-Za-z.'\s/_-]*$/;
    this.nameyRegex = /^[A-Za-z0-9.\s,/_-]*$/;
    this.textArearRegex = /^(.|\s)*[a-zA-Z]+(.|\s)*$/;
    // this.emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
    this.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.telRegex = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;
    // this.urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
    this.passRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d){6,}.+$");
  }

  isEmpty(input) {
    if (input == "" || input == null) {
      return true;
    } else {
      return false;
    }
  }

  validateName(name) {
    const bul = this.nameRegex.test(name);
    return bul;
  }

  validateTextArea(text) {
    const bul = this.textArearRegex.test(text);
    return bul;
  }

  validateTel(tel) {
    const bul = this.telRegex.test(tel);
    return bul;
  }

  isPasswordLongEnough(password) {
    return password.length >= 8;
  }
  passwordHasUpperAndLowerCase(password) {
    return /[A-Z]/.test(password) && /[a-z]/.test(password);
  }

  passwordHasNumberAndSymbol(password) {
    return /[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password);
  }

  validatePassword(password) {
    const bul = this.passRegex.test(password);
    return bul;
  }

  isValidEmail(email) {
    const bul = this.emailRegex.test(email);
    return bul;
  }

  capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  toTitleCase(str) {
    if (typeof str !== "string" || str.length === 0) {
      return str;
    }
    return str
      .split(" ")
      .map((word) => {
        if (word.length === 0) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  }

  truncate(text, maxLength) {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  }

  formatDate(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return "N/A";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    return new Intl.DateTimeFormat("en-US", options).format(date);
  }

  maskAccountNumber(accountNumber) {
    return accountNumber.replace(/\d(?=\d{4})/g, "*");
  }

  formatAccountNumber(accountNumber) {
    return accountNumber.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
  }

  convertImageToBase64(url) {
    return new Promise((resolve, reject) => {
      // const reader = new FileReader();
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Needed if the image is served from a different origin
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = reject;
      img.src = url;
    });
  }
}

//   const helperFunctions = new HelperFunctions();
export default HelperFunctions;
